import { css } from '@emotion/core'
import { colors, measures, spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit } = measures

// Mobile header styles (Detail/Navigation pattern)
export const mobileHeader = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  background-color: #000000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
  ${MQ.NOT_TABLETS} {
    display: none;
  }
`

export const headerContainer = css`
  display: flex;
  align-items: center;
  padding: ${spacing(4)} ${spacing(2)};
  position: relative;
`

export const backArrow = css`
  color: #ffffff;
  font-size: 22px;
  cursor: pointer;
  user-select: none;
  position: absolute;
  left: ${spacing(2)};
  top: 50%;
  transform: translateY(-50%);
  
  &:hover {
    opacity: 0.8;
  }
`

export const titleContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`

export const headerTitle = css`
  color: ${colors.white100};
  margin: 0;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export const contentWrapper = css`
  ${MQ.TABLETS} {
    padding-top: 70px; /* Reduced gap below header */
  }
  position: relative;
  z-index: 1;
  height: 100%;
  overflow: hidden;
`

export const panel = css`
  height: 80vh;
  position: relative;
  z-index: 1;
  
  ${MQ.TABLETS} {
    height: calc(100vh - 140px); /* Account for fixed header (70px) and bottom nav (70px) */
    background-color: ${colors.black100};
    overflow: hidden;
  }
`

export const title = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  ${MQ.TABLETS} {
    display: none; /* Hide desktop title on mobile - use header instead */
  }
`

export const pageWrapper = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  padding: ${spacing(2)} ${spacing(2)}; /* Reduced top padding */
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  ${MQ.TABLETS} {
    overflow: hidden;
    padding: ${spacing(1)} ${spacing(2)}; /* Even less padding on mobile */
  }
`

export const formContent = css`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`

export const description = css`
  color: ${colors.white60};
  line-height: 1.4;
  text-align: left;
  margin: 0 ${spacing(2)};
`

export const receiptsContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  margin-top: ${spacing(1)}; /* Reduced top margin */
  padding: 0 ${spacing(2)};
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  
  ${MQ.TABLETS} {
    margin-top: ${spacing(0.5)}; /* Very small top margin on mobile */
    padding-bottom: ${spacing(2)}; /* Minimal padding for mobile */
    max-height: calc(100vh - 200px); /* Restrict height to prevent overflow */
    overflow: hidden;
  }
`

export const receiptInfo = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(0.5)};
  flex: 1;
  align-items: flex-start;
  justify-content: center;
`

export const yearText = css`
  color: ${colors.white100};
  margin: 0;
  text-align: left;
  font-weight: 600;
`

export const receiptActions = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 80px;
`

export const receiptRow = css`
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: ${spacing(2)};
  padding: ${spacing(2)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
  max-width: 500px;
  margin: 0 0 ${spacing(1.5)} 0;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  min-height: ${spacing(8)};
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.08);
  }
  

`

export const buttonGroup = css`
  display: flex;
  gap: ${spacing(1)};
  align-items: center;
  justify-content: center;
  flex-direction: row;
  align-content: center;
`

export const iconButton = css`
  background: none;
  border: none;
  cursor: pointer;
  padding: ${spacing(0.75)};
  border-radius: ${spacing(1.5)};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  width: ${unit * 6}px;
  height: ${unit * 6}px;
  min-width: ${unit * 6}px;
  min-height: ${unit * 6}px;
  position: relative;
  flex-shrink: 0;
  vertical-align: middle;

  &:hover:not(:disabled) {
    background: rgba(90, 201, 138, 0.2);
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  svg {
    color: #5AC98A;
    font-size: 12px;
    display: block;
    vertical-align: middle;
  }
`

export const downloadButton = css`
  transform: translateY(-1px);
  
  &:hover:not(:disabled) {
    background: rgba(90, 201, 138, 0.3);
    transform: translateY(-2px);
    
    svg {
      color: #4BB079;
    }
  }
  
  &:active:not(:disabled) {
    transform: translateY(-1px);
  }
`

export const emailButton = css`
  &:hover:not(:disabled) {
    background: rgba(90, 201, 138, 0.3);
    
    svg {
      color: #4BB079;
    }
  }
`

export const disabledButton = css`
  cursor: not-allowed;
  opacity: 0.5;

  &:hover {
    background: none !important;
    transform: none !important;
  }

  svg {
    color: rgba(90, 201, 138, 0.4) !important;
  }
`

export const loadingSpinner = css`
  width: 14px;
  height: 14px;
  border: 2px solid rgba(90, 201, 138, 0.3);
  border-top: 2px solid #5AC98A;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`

export const tooltip = css`
  padding: ${spacing(2)};
  background-color: ${colors.grays.gray4};
  border-radius: ${unit * 1}px;
  max-width: 280px;
  text-align: center;
  line-height: 1.3;
  
  /* Position tooltip appropriately for icon buttons */
  margin-top: ${spacing(1)};
`

export const mobileTooltipOverlay = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing(4)};
  animation: fadeIn 0.3s ease-out;
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  ${MQ.NOT_TABLETS} {
    display: none;
  }
`

export const mobileTooltip = css`
  background-color: ${colors.grays.gray4};
  border-radius: ${spacing(2)};
  padding: ${spacing(3)} ${spacing(2.5)};
  max-width: calc(100vw - ${spacing(8)});
  width: 320px;
  text-align: center;
  line-height: 1.4;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: slideUpScale 0.3s ease-out;
  
  @keyframes slideUpScale {
    from {
      opacity: 0;
      transform: translateY(20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`

export const emptyState = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${spacing(8)} ${spacing(4)};
  margin-top: ${spacing(4)};
`

export const emptyText = css`
  color: ${colors.white60};
  line-height: 1.5;
  max-width: 300px;
`